// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"fS-z","smallCardRow":"gS-z","largeCardRow":"hS-z","productSearchRow":"iS-z","curatedRow":"jS-z"};